import { useEffect, useRef } from "react";
import { connect } from "react-redux";

import {
  identifyWebEngageUser,
  logoutWebEngageUser,
} from "./webengageService";

/**
 * Keeps WebEngage user identity in sync with Redux auth state.
 * Covers persisted sessions and logout. Login/signup events are fired
 * from the auth success handlers (not on every page refresh).
 */
const WebEngageAuthSync = ({ isAuthenticated, user, mobileNumber }) => {
  const wasAuthenticatedRef = useRef(isAuthenticated);
  const logoutTrackedRef = useRef(false);

  useEffect(() => {
    try {
      if (isAuthenticated && user?.user_id) {
        logoutTrackedRef.current = false;
        console.log("[WebEngage] Auth sync: session active", {
          userId: user.user_id,
          email: user.email ?? null,
          name: user.name ?? null,
          mobile: user.mobile ?? mobileNumber ?? null,
        });
        identifyWebEngageUser(user, { fallbackMobile: mobileNumber });
        wasAuthenticatedRef.current = true;
        return;
      }

      if (wasAuthenticatedRef.current && !isAuthenticated) {
        if (!logoutTrackedRef.current) {
          logoutTrackedRef.current = true;
          console.log("[WebEngage] Auth sync: logout flow detected");
          logoutWebEngageUser();
        }
      }

      wasAuthenticatedRef.current = isAuthenticated;
    } catch (error) {
      console.error("[WebEngage] Auth sync failed", error);
    }
  }, [isAuthenticated, user, mobileNumber]);

  return null;
};

const mapStateToProps = (state) => ({
  isAuthenticated: state.auth.isAuthenticated,
  user: state.auth.user,
  mobileNumber: state.auth.mobile_number,
});

export default connect(mapStateToProps)(WebEngageAuthSync);
